import { IntroScreenUIConfig } from "../../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../../components/ui/scenario-info-ui";
import GameManager from "../../cvp-webgames-core/GameManager";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from "../../cvp-webgames-core/pre-caching/pre-cache-item";
import { PageType } from "../../misc/tools";
import { GameBaseScenario } from "../GameBaseScenario";
import { scenario9GtubeMedAdmVideoSegments } from "../scenario9-gtube-med-adm/scenario9-gtube-med-adm";
import FallWithInjuryComponentsStep0Component from "./components/fall-with-injury-components-step0/fall-with-injury-components-step0";
import FallWithInjuryComponentsStep0Part1 from "./components/fall-with-injury-components-step0/fall-with-injury-components-step0-parts/fall-with-injury-components-step0-part1";
import FallWithInjuryComponentsStep1Component from "./components/fall-with-injury-components-step1/fall-with-injury-components-step1";
import FallWithInjuryComponentsStep1Part1 from "./components/fall-with-injury-components-step1/fall-with-injury-components-step1-parts/fall-with-injury-components-step1-part1";
import FallWithInjuryComponentsStep2Component from "./components/fall-with-injury-components-step2/fall-with-injury-components-step2";
import FallWithInjuryComponentsStep2Part1 from "./components/fall-with-injury-components-step2/fall-with-injury-components-step2-parts/fall-with-injury-components-step2-part1";

class Scenario10FallWithInjuryVideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Scenario 10 Fall With Injury';
    }
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'Scenario 10 Video 1',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario10/sc10-cinematic/cin-sc-10.mp4',
				chapterIds: [
					'Chapter 1'
				]
			},
			{
				key: 'MixedMedia',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario10/sc10-mentor/mntr-sc-10.mp4', // change this
				chapterIds: [
					'step-2'// alan to update premiere file with audios lol at the end of the time code.
				]
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario10/sc10-mentor/mntr-sc-10.mp4', // change this
				chapterIds: [
					'scenario10-5', //question 1 correct - don't delete comment!
					'scenario10-3', //question 1 incorrect - don't delete comment!
					'scenario10-4', //question 1 other option - don't delete comment!
					'scenario10-9',//question 2 correct - don't delete comment!
					'scenario10-7', //question 2 incorrect - don't delete comment!
					'scenario10-8', //question 2 other option - don't delete comment!
					'scenario10-13', //question 3 correct - don't delete comment!
					'scenario10-12', //question 3 incorrect - don't delete comment!
					'scenario10-15', //question 4 correct - don't delete comment!
					'scenario10-16', //question 4 incorrect - don't delete comment!
					'scenario10-17', //question 4 other option - don't delete comment!
					'scenario10-20', //question 5 correct - don't delete comment!
					'scenario10-19', //question 5 incorrect - don't delete comment!
					'scenario10-1', //scenario info 
					'scenario10-21' //scenario review 
				]
			}
		];
	}
}

export const scenario10FallWithInjuryVideoSegments = new Scenario10FallWithInjuryVideoSegments();

class Scenario10FallWithInjuryAudioCaching extends PreCacheItem {
    public audioKeys = {
        question1: 'question1',
        question2: 'question2',
        question3: 'question3',
        question4: 'question4',
        question5: 'question5'
    };
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question1,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-10/mentor/jcdst-mentor-vo-scn-10-04.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question2,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-10/mentor/jcdst-mentor-vo-scn-10-09.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question3,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-10/mentor/jcdst-mentor-vo-scn-10-15.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question4,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-10/mentor/jcdst-mentor-vo-scn-10-19.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question5,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-10/mentor/jcdst-mentor-vo-scn-10-24.mp3'
			}
		];
	}
}

export const scenario10FallWithInjuryAudioCaching = new Scenario10FallWithInjuryAudioCaching();

export default class Scenario10FallWithInjury extends GameBaseScenario {
	public comp1Step1FirstSelectedChoiceIndex: number = -1;
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return {
			scenarioId: PageType.Scenario10FallWithInjury,
			title: 'Fall with Injury',
			subtitle: 'Situation/Background',
			img: process.env.PUBLIC_URL + '/assets/images/scenarios/sample-image.png',
			description: `
				<p class="small-text" style="margin: 20px; text-align: center">
				After this learning activity you will be able to apply the Just Culture Decision Support Tool after an adverse event occurs.
				
				Patient, age 78, sustained a fall with a serious injury, a hip fracture, requiring surgery. 
				Staff responding to the fall reported that the patient was found on the floor and the call 
				light was above the overhead light.
				</p>
			`,
			mentorVideoUrl: scenario10FallWithInjuryVideoSegments.getItemByKey('Feedback').src,
			mentorChapterId: scenario10FallWithInjuryVideoSegments.getItemByKey('Feedback').chapterIds[13]
		}
    }
	public getMentorVideoURLs(): SingleVideoSegmentItem[] {
		return [
			scenario10FallWithInjuryVideoSegments.getItemByKey('MixedMedia'),
			scenario10FallWithInjuryVideoSegments.getItemByKey('Feedback'),
		] 
	}
	public resumeScenarioFromArea(areaIndx: number): void {
		switch(areaIndx) {
			case 0:
				(this.step0Component.parts[0] as FallWithInjuryComponentsStep0Part1).section2();
				break;
			case 1:
				(this.step0Component.parts[0] as FallWithInjuryComponentsStep0Part1).section3();
				break;
			case 2:
				(this.step1Component.parts[0] as FallWithInjuryComponentsStep1Part1).section2();
				break;
			case 3:
				(this.step1Component.parts[0] as FallWithInjuryComponentsStep1Part1).section3();
				break;
			case 4:
				(this.step2Component.parts[0] as FallWithInjuryComponentsStep2Part1).section1();
				break;
			case 5:
				(this.step2Component.parts[0] as FallWithInjuryComponentsStep2Part1).section2();
				break;
			case 6:
				(this.step1Component.parts[0] as FallWithInjuryComponentsStep1Part1).section1();
				break;
		}
	}

	//VALUES BELOW ARE FOR DEBUG PURPOSES IN CASE STEP 1 is SKIPPED
	// public comp1Step1FirstSelectedChoiceIndex: number = 0;
	public scenarioId(): PageType {
		return PageType.Scenario10FallWithInjury;
    }

	private video: SingleVideoSegmentItem = scenario10FallWithInjuryVideoSegments.getItemByKey('Scenario 10 Video 1');
	public getScenarioVideoURL(): string {
		return this.video.src;
	}
	public introScreenInfo(): IntroScreenUIConfig {
		return {
			title: 'Fall with Injury',
			subtitle: 'Incident Report',
			name: 'Pedro',
			position: 'Nurse (New Graduate)',
			time: 'Day Shift',
			place: 'Medical-Surgical Unit',
			desc: `Patient, age 78, sustained a fall with a serious injury (hip fracture requiring surgery). Staff 
			responding to the fall reported that the patient was found on the floor and the call light was 
			above the overhead light.`,
			repeat: 'No',
			okButton: 'Continue'
		}
	}

	private step0Component = new FallWithInjuryComponentsStep0Component({
		scenario: this,
		onDone: () => {
			this.goToStep1Component();
		}
	})

	private step1Component = new FallWithInjuryComponentsStep1Component({
		scenario: this,
		onDone: () => {
			this.goToStep2Component();
		}
	})

	private step2Component = new FallWithInjuryComponentsStep2Component({
		scenario: this,
		onDone: () => {
			this.uiWrapper.displayAAR();
		}
	})

	private parts: BaseScenarioPart<GameBaseScenario>[] = [].concat(this.step0Component.parts)
		.concat(this.step1Component.parts)
		.concat(this.step2Component.parts);

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
		this._setupStep0Component();
		this._setupStep1Component();
		this._setupStep2Component();
	}

	start() {
		this.goToStep0Component();
	}

	private _setupStep0Component() {
		this.step0Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep1Component() {
		this.step1Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep2Component() {
		this.step2Component.config.part1Config = {
			videoUrl: this.video.src
		}
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	goToStep0Component() {
		this.step0Component.start();
	}

	goToStep1Component() {
		this.step1Component.start();
	}

	goToStep2Component() {
		this.step2Component.start();
	}
}